// src/components/TermsOfService.js
import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/App.css'; // Ensure consistent styling

function TermsOfService() {
  return (
    <main className="terms-of-service-page page-wrap">
      <Helmet>
        <title>Terms of Service | WizeAssist</title>
        <meta
          name="description"
          content="Read the Terms of Service for WizeAssist to understand the rules and regulations governing the use of our platform."
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Terms of Service | WizeAssist" />
        <meta
          property="og:description"
          content="Read the Terms of Service for WizeAssist to understand the rules and regulations governing the use of our platform."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.wizeassist.com/terms" />
        <meta
          property="og:image"
          content="https://www.wizeassist.com/assets/images/og-image-terms.jpg"
        /> {/* Replace with actual image */}
    
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms of Service | WizeAssist" />
        <meta
          name="twitter:description"
          content="Read the Terms of Service for WizeAssist to understand the rules and regulations governing the use of our platform."
        />
        <meta
          name="twitter:image"
          content="https://www.wizeassist.com/assets/images/twitter-image-terms.jpg"
        />
    
        {/* Structured Data for Terms of Service Page */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms of Service",
            "description":
              "Read the Terms of Service for WizeAssist to understand the rules and regulations governing the use of our platform.",
            "url": "https://www.wizeassist.com/terms",
          })}
        </script>
      </Helmet>
    
      <h1 className="text-teal mb-4">Terms of Service</h1>
      <div className="container">
        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using WizeAssist, you accept and agree to be bound by the terms and 
            provision of this agreement. In addition, when using WizeAssist’s particular services, 
            you shall be subject to any posted guidelines or rules applicable to such services.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>2. Description of Service</h2>
          <p>
            WizeAssist provides an AI-driven sports training platform that offers real-time insights,
            performance tracking, and personalized training programs. You agree to use the service 
            only for purposes that are permitted by (a) the Terms and (b) any applicable law.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>3. User Responsibilities</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account and password, 
            including but not limited to the restriction of access to your computer and/or account.
            You agree to accept responsibility for any and all activities or actions that occur under
            your account and/or password.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>4. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are and will remain
            the exclusive property of WizeAssist and its licensors. The content is protected by 
            copyright, trademark, and other laws of both the United States and foreign countries.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>5. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability,
            for any reason whatsoever, including without limitation if you breach the Terms.
    
            Upon termination, your right to use the Service will immediately cease.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            In no event shall WizeAssist, nor its directors, employees, partners, agents, suppliers,
            or affiliates, be liable for any indirect, incidental, special, consequential or punitive 
            damages, including without limitation, loss of profits, data, use, goodwill, or other 
            intangible losses, resulting from (i) your access to or use of or inability to access 
            or use the Service; (ii) any conduct or content of any third party on the Service; 
            (iii) any content obtained from the Service; and (iv) unauthorized access, 
            use or alteration of your transmissions or content, whether based on warranty, 
            contract, tort (including negligence) or any other legal theory, whether or not we 
            have been informed of the possibility of such damage.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>7. Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of [Your State],
            without regard to its conflict of law provisions.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any 
            time. If a revision is material we will provide at least 30 days' notice prior to any 
            new terms taking effect. What constitutes a material change will be determined at our 
            sole discretion.
          </p>
        </section>
    
        <section className="terms-section">
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us:
          </p>
          <ul>
            <li>Email: <a href="mailto:support@wizeassist.com">support@wizeassist.com</a></li>
            <li>Phone: +1-800-123-4567</li>
          </ul>
        </section>
      </div>
    </main>
  );
}   
    export default TermsOfService;
